/**
 * Get trial due date
 * @param {object} order
 * @param {object} theme
 * @param {boolean} [isThankYouPage]
 * @returns {string|null}
 */
export default (order, theme, isThankYouPage = false) => {
	if (order.hasTrialProduct) {
		const trialPeriod = order.trialPeriod;
		const date = isThankYouPage ? Date.parse(order.orderDate) : Date.now();
		const dueDate = new Date(date + trialPeriod * 86400000); // 86400000ms is 1 day
		const utcDueDate = new Date(dueDate.valueOf() + dueDate.getTimezoneOffset() * 60000);
		const locale = theme.provider.locale.split('_').join('-');
		return utcDueDate.toLocaleDateString(locale, {
			month: 'long',
			day: 'numeric'
		});
	} else {
		return null;
	}
};
